import { NgModule } from '@angular/core';
import { RxUploadThumbGroupListComponent } from './rx-upload-thumb-group-list.component';
import { RxSearchModule } from '@nrwl/rx-ui';
import { RxIconModule } from '@nrwl/rx-icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxCheckboxModule } from '@nrwl/rx-checkbox';
import { RxPipesModule } from '@nrwl/rx-pipes';

@NgModule({
  imports: [
    RxSearchModule,
    FormsModule,
    ReactiveFormsModule,
    RxIconModule,
    RxCheckboxModule,
    RxPipesModule,
    RxUploadThumbGroupListComponent,
  ],
  exports: [RxUploadThumbGroupListComponent],
})
export class RxUploadThumbGroupListModule {}
